<div class="auth-login">
  <div class="auth-login-forgot-password__content">
    <div class="auth-login__form auth-login__forgot-password">
        <div class="auth-login-forgot-password__notif-info mb40" *ngIf="formSubmitted && lastSentEmail">
            <p>If account with <b>{{lastSentEmail}}</b> exists, you will get an email how to reset your password.</p>
        </div>
        <img [src]="companyInfo?.branding?.cache_icon_big || 'assets/images/logos/logo_placeholder.png'" />
      <h1 class="auth-login__form-title">{{'text_accountRecovery' | dbText}}</h1>

      <form [formGroup]="sendResetMailForm" (ngSubmit)="onSendResetMailSubmit()">

        <div class="auth-login__info">
          <p [innerHTML]="'text_forgotPasswordEmailDesc' | dbText" class="auth-login__desc"></p>
        </div>

        <!-- *** Uncomment If Errors is needed *** -->
        <!--<div class="auth-login-forgot-password__notif-error" *ngIf="rateLimitError">
          <i class="db-icon db-icon-ds-exclamation-bg"></i>
          <p>You are over the limit of requesting password resets.<br> Please try again later.</p>
        </div>-->

        <div class="ds-input-wrap mb11">
          <input class="ds-input-black" maxlength="100" type="email" name="email" placeholder="Email address" formControlName="email"  x-autocompletetype="email"
                 [ngClass]="{'error': sendResetMailForm.controls['email'].invalid && ((sendResetMailForm.controls['email'].touched && !sendResetMailForm.controls['email'].errors['required']) || formSubmitted)}">
          <span *ngIf="(sendResetMailForm.controls['email'].invalid && ((sendResetMailForm.controls['email'].touched && !sendResetMailForm.controls['email'].errors['required']) || formSubmitted))" class="ds-input-error-msg">
              <i class="db-icon db-icon-ds-notice"></i>{{'text_invalidEmail' | dbText}}</span>
        </div>

        <div class="db-login-button-wrap">
          <button class="ds-btn-black ds-btn-max m" [ngClass]="{'ds-btn-disabled': loading}"
                  [disabled]="loading" type="submit">
            <span *ngIf="!loading" [innerHTML]="'text_forgotPasswordSubmit' | dbText | lowerCaseSpecificWords"></span>
            <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
          </button>
        </div>
      </form>
    </div>
    <div>

    </div>
  </div>
</div>
